import Header from "../components/landing/Header";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import Privacy from "../components/landing/Privacy";
import Terms from "../components/landing/Terms";
import Support from "../components/landing/Support";
import Footer from "../components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-neutral-950 font-[Instrument_Sans] overflow-x-hidden">
      <Header />
      <Hero />
      <Features />
      <Privacy />
      <Terms />
      <Support />
      <Footer />
    </main>
  );
}
